import {isFunction} from '@malt/common';
import {registry} from './registry';

export function defineModule(name, moduleDefinitionFn) {
    if (!isFunction(moduleDefinitionFn)) {
        throw new Error('Invalid module definition: must be a function!');
    }

    if (!registry.contains(name)) {
        registry.store(name, moduleDefinitionFn);
    } else {
        Hop.logError(new Error('module "' + name + '" already defined'));
    }
}
